import { sortBy } from 'lodash';

export const roleChoices = [
  { id: 'ar', name: 'A&R' },
  { id: 'atmos-mix-engineer', name: 'Atmos Mix Engineer' },
  { id: 'audio-engineer', name: 'Audio Engineer' },
  { id: 'composer', name: 'Composer' },
  { id: 'cutting-engineer', name: 'Cutting Engineer' },
  { id: 'mixer', name: 'Mixer' },
  { id: 'musician', name: 'Musician' },
  { id: 'producer', name: 'Producer' },
  { id: 'recording-engineer', name: 'Recording Engineer' },
  { id: 'remixer', name: 'Remixer' },
  { id: 'songwriter', name: 'Songwriter' },
];

export const industryRoleChoices = [
  { id: 'Atmos Mastering Engineer', name: 'Atmos Mastering Engineer' },
  { id: 'Producer', name: 'Producer' },
  { id: 'Mastering Engineer', name: 'Mastering Engineer' },
  { id: 'Mixing Engineer', name: 'Mixing Engineer' },
];

export const genreChoices = sortBy([
  { id: 'rock', name: 'Rock' },
  { id: 'pop', name: 'Pop' },
  { id: 'hiphop_rap', name: 'Hip-Hop / Rap' },
  { id: 'rnb_soul', name: 'R&B / Soul' },
  { id: 'electronic', name: 'Electronic / Dance (EDM)' },
  { id: 'k-pop', name: 'K-Pop' },
  { id: 'j-pop', name: 'J-Pop' },
  { id: 'metal_hardrock', name: 'Metal / Hard Rock' },
  { id: 'country', name: 'Country' },
  { id: 'jazz', name: 'Jazz' },
  { id: 'blues', name: 'Blues' },
  { id: 'classical', name: 'Classical' },
  { id: 'reggae_dancehall', name: 'Reggae / Dancehall' },
  { id: 'latin_reggaeton', name: 'Latin / Reggaeton' },
  { id: 'indie_alternative', name: 'Indie / Alternative' },
  { id: 'folk_americana', name: 'Folk / Americana' },
  { id: 'funk', name: 'Funk' },
  { id: 'worship_christian', name: 'Worship / Christian' },
  { id: 'punk', name: 'Punk' },
  { id: 'singer-songwriter', name: 'Singer-Songwriter' },
  { id: 'soundtrack', name: 'Soundtrack' },
  { id: 'world', name: 'World' },
  { id: 'new-age', name: 'New Age' },
  { id: 'childrens', name: 'Childrens' },
  { id: 'spoken-word', name: 'Spoken Word' },
], 'name');

export const awardShowChoices = [
  { id: 'grammy', name: 'Grammy' },
  { id: 'grammy_latin', name: 'Grammy Latin' },
];

export const grammyCategoryChoices = [
  { id: 'record_of_the_year', name: 'Record of the Year' },
  { id: 'album_of_the_year', name: 'Album of the Year' },
  { id: 'best_historical_album', name: 'Best Historical Album' },
  { id: 'best_engineered_album', name: 'Best Engineered Album' },
  { id: 'best_engineered_album_classical', name: 'Best Engineered Album, Classical' },
  { id: 'best_immersive_audio_album', name: 'Best Immersive Audio Album' },
];

export const releaseTypeChoices = [
  { id: 'album', name: 'Album' },
  { id: 'single', name: 'Single' },
  { id: 'ep', name: 'EP' },
];
